// React
import { useCallback, useState } from 'react';
// External libs
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
// Tools
import { useFormatMessage } from '../../intl/intl';
// Consts
import { textIds } from './consts';
// Components
import CustomSwipeableDialog from '../common/custom-swipeable-dialog';
import CustomTextField from '../common/custom-text-field';
// Actions
import dialogsManagerActions from '../../redux/actions/dialogsManager.actions';
// Hooks
import hooks from './hooks';
// Styles
import useStyles from './styles';
import CustomRadio from '../common/custom-radio';
// Material UI
import { RadioGroup } from '@material-ui/core';
// Actions
import AppActions from '../../redux/actions/app-actions/app.actions';
import rootActions from '../../redux/actions/root.actions';

export function LogOutReasonsDialog() {
  const open = hooks.useOpen();
  const logOutReasons = hooks.useLogOutReasons();
  const componentClasses = useStyles();
  const cancelButtonText = useFormatMessage(textIds.cancelButtonText);
  const confirmButtonText = useFormatMessage(textIds.confirmButtonText);
  const title = useFormatMessage(textIds.title);
  const placeHolder = useFormatMessage(textIds.placeHolder);
  const [currentValue, setCurrentValue] = useState<string>('');

  const [currentDescriptionReason, setCurrentDescriptionReason] = useState<
    string | null | undefined
  >('');
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(dialogsManagerActions.close());
    setCurrentValue('');
    setCurrentDescriptionReason('');
  }, [dispatch]);

  const handleDescriptionReasonBox = useCallback(e => {
    const eventValue = get(e, 'currentTarget.value', '');
    setCurrentDescriptionReason(eventValue);
  }, []);

  const handleConfirm = useCallback(async () => {
    try {
      dispatch(rootActions.logout(currentValue, currentDescriptionReason));
      dispatch(dialogsManagerActions.close());
      setCurrentValue('');
      setCurrentDescriptionReason('');
    } catch (ex) {
      await dispatch(AppActions.handleCatch(ex));
      dispatch(dialogsManagerActions.close());
    }
  }, [dispatch, currentDescriptionReason, currentValue]);

  const handleReasonToLogOut = useCallback(
    e => {
      const eventValue = get(e, 'currentTarget.value', 0);
      setCurrentValue(eventValue);
      if (eventValue !== currentValue) {
        setCurrentDescriptionReason('');
      }
    },
    [currentValue],
  );

  return (
    <CustomSwipeableDialog
      classes={{
        dialogPaper: componentClasses.root,
        contentContainer: componentClasses.container,
        title: componentClasses.title,
        titleContainer: componentClasses.titleBox,
      }}
      open={open}
      title={title}
      message={''}
      buttons={[
        {
          onClick: handleClose,
          label: cancelButtonText,
          variant: 'outlined',
          color: 'tertiary',
        },
        {
          color: 'primary',
          label: confirmButtonText,
          onClick: handleConfirm,
          variant: 'contained',
          disabled: !currentValue,
        },
      ]}
    >
      <RadioGroup value={currentValue}>
        {logOutReasons &&
          logOutReasons.map((reason, index) => {
            return (
              <div key={`reasons-index-${index}`}>
                <CustomRadio
                  key={`reasons-index-checkbox-${reason.reasonId}`}
                  color='primary'
                  label={reason.reasonText}
                  value={reason.reasonId}
                  onChange={handleReasonToLogOut}
                />
                <div>
                  {currentValue === reason.reasonId && (
                    <CustomTextField
                      classes={{
                        textFieldRoot: componentClasses.contentBox,
                      }}
                      fullWidth={false}
                      name='input'
                      multiline
                      label={placeHolder}
                      rows={4}
                      variant='outlined'
                      value={currentDescriptionReason}
                      onChange={handleDescriptionReasonBox}
                      maxLength={200}
                    />
                  )}
                </div>
              </div>
            );
          })}
      </RadioGroup>
    </CustomSwipeableDialog>
  );
}
